import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=b3048d38&scoped=true"
import script from "./OrderEdit.vue?vue&type=script&lang=js"
export * from "./OrderEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderEdit.vue?vue&type=style&index=0&id=b3048d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3048d38",
  null
  
)

export default component.exports